function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getLeaderUserVerifyLimitList, saveLeaderUserVerifyLimit, disableLeaderUserVerifyLimit } from '@/api/distributionAlliance';
import { storeLeaderOptionsApi } from '@/api/distributionStore';
export default {
  name: 'AllianceVerifyLimit',
  data: function data() {
    return {
      loading: false,
      saving: false,
      list: [],
      users: {},
      total: 0,
      query: {
        leaderUid: null,
        status: null,
        page: 1,
        size: 20
      },
      dialogVisible: false,
      form: this.emptyForm(),
      leaderList: [],
      leaderLoading: false,
      rules: {
        leaderUid: [{
          required: true,
          message: '请输入团长 uid',
          trigger: 'blur'
        }],
        dailyScanLimit: [{
          required: true,
          message: '请输入每日次数上限',
          trigger: 'blur'
        }],
        dailyPointsLimit: [{
          required: true,
          message: '请输入每日积分上限',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.load(1);
  },
  methods: {
    emptyForm: function emptyForm() {
      return {
        id: null,
        leaderUid: null,
        dailyScanLimit: 0,
        dailyPointsLimit: 0,
        status: 1
      };
    },
    clean: function clean(query) {
      var params = {};
      Object.keys(query).forEach(function (key) {
        var value = query[key];
        if (value !== '' && value !== null && value !== undefined && !Number.isNaN(value)) params[key] = value;
      });
      return params;
    },
    load: function load(page) {
      var _this = this;
      if (page) this.query.page = page;
      this.loading = true;
      getLeaderUserVerifyLimitList(this.clean(this.query)).then(function (res) {
        _this.list = res && res.list || [];
        _this.users = res && res.users || {};
        _this.total = res && res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    onSize: function onSize(size) {
      this.query.size = size;
      this.load(1);
    },
    reset: function reset() {
      this.query = {
        leaderUid: null,
        status: null,
        page: 1,
        size: 20
      };
      this.load(1);
    },
    userName: function userName(uid) {
      var user = this.users[uid];
      return user ? user.nickname || '（未设置昵称）' : '查无此人';
    },
    userPhone: function userPhone(uid) {
      var user = this.users[uid];
      return user && user.phone ? " \xB7 ".concat(user.phone) : '';
    },
    today: function today(row) {
      if (!row.usageDate) return false;
      var value = String(row.usageDate).replace(/-/g, '/').slice(0, 10);
      var now = new Date();
      var today = "".concat(now.getFullYear(), "/").concat(String(now.getMonth() + 1).padStart(2, '0'), "/").concat(String(now.getDate()).padStart(2, '0'));
      return value === today;
    },
    openCreate: function openCreate() {
      var _this2 = this;
      this.form = this.emptyForm();
      this.leaderList = [];
      this.dialogVisible = true;
      this.$nextTick(function () {
        return _this2.$refs.form && _this2.$refs.form.clearValidate();
      });
      this.searchLeader('');
    },
    openEdit: function openEdit(row) {
      var _this3 = this;
      this.form = {
        id: row.id,
        leaderUid: row.leaderUid,
        dailyScanLimit: Number(row.dailyScanLimit) || 0,
        dailyPointsLimit: Number(row.dailyPointsLimit) || 0,
        status: row.status === 1 ? 1 : 0
      };
      this.leaderList = this.form.leaderUid ? [{
        uid: this.form.leaderUid,
        nickname: this.userName(this.form.leaderUid),
        phone: ''
      }] : [];
      this.dialogVisible = true;
      this.$nextTick(function () {
        return _this3.$refs.form && _this3.$refs.form.clearValidate();
      });
      this.searchLeader('');
    },
    searchLeader: function searchLeader(keyword) {
      var _this4 = this;
      this.leaderLoading = true;
      storeLeaderOptionsApi({
        limit: 30,
        keywords: keyword || ''
      }).then(function (data) {
        var list = data || [];
        var picked = _this4.leaderList.find(function (item) {
          return item.uid === _this4.form.leaderUid;
        });
        _this4.leaderList = picked && !list.some(function (item) {
          return item.uid === picked.uid;
        }) ? [picked].concat(_toConsumableArray(list)) : list;
      }).finally(function () {
        _this4.leaderLoading = false;
      });
    },
    leaderLabel: function leaderLabel(item) {
      var name = item.nickname || '未命名';
      return "".concat(name, "\uFF08uid ").concat(item.uid).concat(item.phone ? "\uFF0C".concat(item.phone) : '', "\uFF09");
    },
    submit: function submit() {
      var _this5 = this;
      this.$refs.form.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
          var _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                if (valid) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2);
              case 1:
                _this5.saving = true;
                _context.p = 2;
                _context.n = 3;
                return saveLeaderUserVerifyLimit({
                  id: _this5.form.id,
                  leaderUid: Number(_this5.form.leaderUid),
                  dailyScanLimit: Number(_this5.form.dailyScanLimit) || 0,
                  dailyPointsLimit: Number(_this5.form.dailyPointsLimit) || 0,
                  status: _this5.form.status
                });
              case 3:
                _this5.$message.success('已保存');
                _this5.dialogVisible = false;
                _this5.load(1);
                _context.n = 5;
                break;
              case 4:
                _context.p = 4;
                _t = _context.v;
              case 5:
                _context.p = 5;
                _this5.saving = false;
                return _context.f(5);
              case 6:
                return _context.a(2);
            }
          }, _callee, null, [[2, 4, 5, 6]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    disable: function disable(row) {
      var _this6 = this;
      this.$confirm('停用后该团长对所有用户不再受此限额限制，确定继续吗？', '提示', {
        type: 'warning'
      }).then(function () {
        return disableLeaderUserVerifyLimit(row.id);
      }).then(function () {
        _this6.$message.success('已停用');
        _this6.load();
      }).catch(function () {});
    }
  }
};